/*
 * Brochure Download Tracking
 * Tracks PDF downloads and brochure link clicks for analytics
 */

function getFileInfo(url) {
  try {
    const urlObj = new URL(url);
    const pathname = urlObj.pathname;
    const filename = pathname.split('/').pop();
    const fileExtension = filename.split('.').pop().toLowerCase();

    return {
      filename: filename,
      fileType: fileExtension
    };
  } catch (error) {
    console.error('Error parsing URL:', error);
    return {
      filename: 'unknown',
      fileType: 'unknown'
    };
  }
}

function isBrochureLink(url) {
  if (!url) return false;

  const lowerUrl = url.toLowerCase();
  return (
    lowerUrl.includes('brochure') || 
    lowerUrl.includes('failte') ||
    // General PDF check for Carroll's CDN files that might be brochures
    (lowerUrl.includes('.pdf') && lowerUrl.includes('cdn.shopify.com'))
  );
}

function trackWithShopify(data) {
  if (typeof Shopify !== 'undefined' && 
      Shopify.analytics && 
      typeof Shopify.analytics.publish === 'function') {

    Shopify.analytics.publish("brochure_download", data);
  }
}

function trackWithDataLayer(data) {
  if (typeof window.dataLayer !== 'undefined') {
    window.dataLayer.push({
      event: 'brochure_download',
      ...data
    });
  }
}

function handleBrochureClick(event) {
  const target = event.target.closest('a');

  if (!target || !target.href) {
    return;
  }

  // Check if this is a brochure link
  if (!isBrochureLink(target.href)) {
    return;
  }

  const fileInfo = getFileInfo(target.href);

  const trackingData = {
    brochure_name: fileInfo.filename,
    File_type: fileInfo.fileType,
    page_title: document.title,
    page_url: window.location.href,
    button_text: target.textContent.trim(),
    timestamp: new Date().toISOString(),
    consent: window.OnetrustActiveGroups || ''
  };

  // Track with both analytics systems
  trackWithShopify(trackingData);
  trackWithDataLayer(trackingData);

}

// Initialize brochure tracking when DOM is ready
document.addEventListener('DOMContentLoaded', function() {
  document.addEventListener('click', handleBrochureClick);
});
